/* tslint:disable */
import * as React from 'react'
import { Redirect } from 'react-router-dom'
import Dropzone from 'react-dropzone'
import axios from 'axios'
import * as R from 'ramda'
import moment from 'moment-timezone'
import { login, getPhotoCol, amIAdmin } from '../../fb'
import Config from '../../config'
import { pipe } from '../../utils/functional'

const { ApiKey: api_key, UploadPreset: upload_preset } = Config.Cloudinary

class PhotosUploader extends React.Component {
  state = {
    canIUpload: false,
    uploadFinished: false,
    accepted: [],
    rejected: [],
  }

  onDrop = (accepted, rejected) => {
    if (accepted.length > 0 && rejected.length === 0) {
      this.setState({ accepted, rejected: [] })
      return this.uploadImages(accepted)
    }
    this.setState({ accepted: [], rejected })
  }

  async uploadImages (files) {
    if (!this.state.canIUpload) { return alert('권한이 없습니다.') }

    try {
      const [ year, month, day ] = moment().tz('Asia/Seoul').format('YYYY-MM-DD').split('-')
      const createdAt = Date.now()
      await pipe(
        () => files.map((file, idx) => {
          return pipe(
            this.mapToFormData(Math.floor(createdAt / 1000).toString()),
            this.uploadToCloudinary,
            R.prop('data'),
            this.mapToDBData({ year, month, day, createdAt: createdAt + idx }),
            this.saveToDB,
          )(file)
        }),
        axios.all,
      )()
      this.setState({ uploadFinished: true })
    } catch (ex) {
      alert('업로드에 실패했습니다. 다시 시도해주세요.')
    }
  }

  mapToFormData = R.curry((timestamp, file) => {
    const formData = new FormData()
    formData.append('file', file)
    formData.append('tags', 'doha')
    formData.append('upload_preset', upload_preset) // Replace the preset name with your own
    formData.append('api_key', api_key) // Replace API key with your own Cloudinary key
    formData.append('timestamp', timestamp)
    return formData
  })

  uploadToCloudinary = formData => axios.post(
    'https://api.cloudinary.com/v1_1/kanziw/image/upload',
    formData,
    { headers: { 'X-Requested-With': 'XMLHttpRequest' } }
  )

  mapToDBData = R.curry((
    { year, month, day, createdAt },
    { public_id, secure_url, resource_type, signature, width, height },
  ) => {
    const [ idPrefix, publicId ] = public_id.split('/')
    return {
      publicId, idPrefix, tags: [ 'doha' ],
      url: secure_url, resourceType: resource_type, signature, width, height,
      year, month, day, createdAt,
    }
  })

  async login () {
    await login()
    if (!amIAdmin()) {
      return alert('권한이 없습니다.')
    }
    this.setState({ canIUpload: true })
  }

  saveToDB = ({ publicId, ...data }) => getPhotoCol().doc(publicId).set(data)

  render () {
    const { uploadFinished, canIUpload } = this.state
    if (!canIUpload) {
      return (
        <div>
          <button onClick={this.login.bind(this)}>Login</button>
        </div>
      )
    }

    return uploadFinished
      ? <Redirect to={'/'} />
      : (
        <section>
          <div>
            <Dropzone onDrop={this.onDrop.bind(this)} accept='image/*'>
              <p>Try dropping some files here, or click to select files to upload.</p>
            </Dropzone>
          </div>
          <aside>
            <h2>Accepted files</h2>
            <ul>
              {
                this.state.accepted.map(f => <li key={f.name}>{f.name} - {f.size} bytes</li>)
              }
            </ul>
            <h2>Rejected files</h2>
            <ul>
              {
                this.state.rejected.map(f => <li key={f.name}>{f.name} - {f.size} bytes</li>)
              }
            </ul>
          </aside>
        </section>
      )
  }
}

export default PhotosUploader



// WEBPACK FOOTER //
// ./src/components/UploadWidget/index.js